import script from "./distributor-verify-code.vue?vue&type=script&lang=ts&setup=true"
export * from "./distributor-verify-code.vue?vue&type=script&lang=ts&setup=true"

import "./distributor-verify-code.vue?vue&type=style&index=0&id=74102a4c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74102a4c"]])

export default __exports__